module.exports = __webpack_public_path__ + "static/media/normal-yd1.07ff8818.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/normal-yd1.png
// module id = 1931
// module chunks = 6